/** @jsxImportSource @emotion/react */
import PropTypes from "prop-types";
import PageSection from "components/PageSection";
import { filtersContainerCss } from "pages/admin/prospects/index.css";
import { gap16Css } from "pages/admin/profile/EditForm/index.css";
import MultiSelectCommonFilter from "pages/admin/prospects/ProspectsCommonFilter/MultiSelectCommonFilter";
import CategoryFilter from "pages/admin/brands/Filters/CategoryFilter";
import ExportInsightsButton from "pages/admin/insights/ExportInsightsButton";
import ProspectsCommonFilter from "pages/admin/prospects/ProspectsCommonFilter";
import TagsSelectFilter from "pages/admin/insights/TagsSelectFilter/TagsSelectFilter";
import { tableContainerCss } from "./index.css";

export default function Layout({ children, isFetching, isLoading, data }) {
  return (
    <>
      <PageSection css={gap16Css} className="flex-a-c-j-sb">
        <div css={filtersContainerCss}>
          <ProspectsCommonFilter filterName="partner" />
          <MultiSelectCommonFilter filterName="brand" />
          <MultiSelectCommonFilter filterName="excludeBrand" />
          <CategoryFilter filterName="category" />
          <MultiSelectCommonFilter filterName="sentiment" />
          <TagsSelectFilter />
        </div>
        <ExportInsightsButton isFetching={isFetching} isLoading={isLoading} data={data} />
      </PageSection>
      <div css={tableContainerCss}>{children}</div>
    </>
  );
}

Layout.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  isFetching: PropTypes.bool,
  isLoading: PropTypes.bool,
  data: PropTypes.arrayOf(PropTypes.shape({})),
};
